import './DeleteBed.scss'
import DeleteBed from "./DeleteBed";

export default DeleteBed;